export default __webpack_public_path__ + "static/media/Commandes_Supprimer.e77262f3.png";